import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  onLine (params) {
    return axios.post(global.MYG_1V1 + '/tutor/online', params)
  },
  offLine (params) {
    return axios.post(global.MYG_1V1 + '/tutor/offline', params)
  },
  findTutorStatus (params) {
    return axios.post(global.MYG_1V1 + '/tutor/findIsOnline', params)
  },
  selectTutor (params) { // 手动分配导师
    return axios.post(global.MYG_1V1 + '/tutor/selectTutor', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/myg/myg.js